import { EntityBase } from '@/bases';

export class Appointment extends EntityBase {
  private _AppointmentDate: Date = null;
  private _AccessedDate: Date = null;
  private _ConfirmedDate: Date = null;
  private _CancelledDate: Date = null;
  private _AppointmentNotification1StatusDate: Date = null;
  private _AppointmentNotification2StatusDate: Date = null;
  private _AppointmentNotification3StatusDate: Date = null;
  private _AppointmentReminder1StatusDate: Date = null;
  private _AppointmentReminder2StatusDate: Date = null;
  private _ModifiedOn: Date = null;

  public get AppointmentId(): string { return this.Id; }
  public set AppointmentId(value: string) { this.Id = value; }

  public ExtID: string = null;
  public AppointmentKey: string = null;
  public get AppointmentDate(): Date { return this._AppointmentDate; }
  public set AppointmentDate(value: Date) { this._AppointmentDate = value === null || value instanceof Date ? value : new Date(value); }
  public Branding: number = null;
  public get AccessedDate(): Date { return this._AccessedDate; }
  public set AccessedDate(value: Date) { this._AccessedDate = value === null || value instanceof Date ? value : new Date(value); }
  public get ConfirmedDate(): Date { return this._ConfirmedDate; }
  public set ConfirmedDate(value: Date) { this._ConfirmedDate = value === null || value instanceof Date ? value : new Date(value); }
  public get CancelledDate(): Date { return this._CancelledDate; }
  public set CancelledDate(value: Date) { this._CancelledDate = value === null || value instanceof Date ? value : new Date(value); }
  public AppointmentNotification1Status: number = null;
  public get AppointmentNotification1StatusDate(): Date { return this._AppointmentNotification1StatusDate; }
  public set AppointmentNotification1StatusDate(value: Date) { this._AppointmentNotification1StatusDate = value === null || value instanceof Date ? value : new Date(value); }
  public AppointmentNotification1Reason: string = null;
  public AppointmentNotification2Status: number = null;
  public get AppointmentNotification2StatusDate(): Date { return this._AppointmentNotification2StatusDate; }
  public set AppointmentNotification2StatusDate(value: Date) { this._AppointmentNotification2StatusDate = value === null || value instanceof Date ? value : new Date(value); }
  public AppointmentNotification2Reason: string = null;
  public AppointmentNotification3Status: number = null;
  public get AppointmentNotification3StatusDate(): Date { return this._AppointmentNotification3StatusDate; }
  public set AppointmentNotification3StatusDate(value: Date) { this._AppointmentNotification3StatusDate = value === null || value instanceof Date ? value : new Date(value); }
  public AppointmentNotification3Reason: string = null;
  public AppointmentReminder1Status: number = null;
  public get AppointmentReminder1StatusDate(): Date { return this._AppointmentReminder1StatusDate; }
  public set AppointmentReminder1StatusDate(value: Date) { this._AppointmentReminder1StatusDate = value === null || value instanceof Date ? value : new Date(value); }
  public AppointmentReminder1Reason: string = null;
  public AppointmentReminder2Status: number = null;
  public get AppointmentReminder2StatusDate(): Date { return this._AppointmentReminder2StatusDate; }
  public set AppointmentReminder2StatusDate(value: Date) { this._AppointmentReminder2StatusDate = value === null || value instanceof Date ? value : new Date(value); }
  public AppointmentReminder2Reason: string = null;
  public get ModifiedOn(): Date { return this._ModifiedOn; }
  public set ModifiedOn(value: Date) { this._ModifiedOn = value === null || value instanceof Date ? value : new Date(value); }
  public ModifiedBy: string = null;

  constructor(data: any = null) {
    super();
    this.Assign(data);
  }

  public toJSON(): any {
    return {
      AppointmentId: this.AppointmentId,
      ExtID: this.ExtID,
      AppointmentKey: this.AppointmentKey,
      AppointmentDate: this.AppointmentDate,
      Branding: this.Branding,
      AccessedDate: this.AccessedDate,
      ConfirmedDate: this.ConfirmedDate,
      CancelledDate: this.CancelledDate,
      AppointmentNotification1Status: this.AppointmentNotification1Status,
      AppointmentNotification1StatusDate: this.AppointmentNotification1StatusDate,
      AppointmentNotification1Reason: this.AppointmentNotification1Reason,
      AppointmentNotification2Status: this.AppointmentNotification2Status,
      AppointmentNotification2StatusDate: this.AppointmentNotification2StatusDate,
      AppointmentNotification2Reason: this.AppointmentNotification2Reason,
      AppointmentNotification3Status: this.AppointmentNotification3Status,
      AppointmentNotification3StatusDate: this.AppointmentNotification3StatusDate,
      AppointmentNotification3Reason: this.AppointmentNotification3Reason,
      AppointmentReminder1Status: this.AppointmentReminder1Status,
      AppointmentReminder1StatusDate: this.AppointmentReminder1StatusDate,
      AppointmentReminder1Reason: this.AppointmentReminder1Reason,
      AppointmentReminder2Status: this.AppointmentReminder2Status,
      AppointmentReminder2StatusDate: this.AppointmentReminder2StatusDate,
      AppointmentReminder2Reason: this.AppointmentReminder2Reason,
      ModifiedOn: this.ModifiedOn,
      ModifiedBy: this.ModifiedBy
    };
  }
}

export enum AppointmentBranding {
  BritishEngineeringServices = 1,
  Vulcan = 2
}